import React, { useEffect } from 'react-x';
import propTypes from 'prop-types-x';
import classNames from 'classnames';
import { CssAnimation } from './CssAnimation.jsx';
import { Overlay } from './Overlay.jsx';
import { publish } from '../../utilities/events.js';

export function Modal(props) {

  const {
    id,
    children,
    brand,
    theme,
    classes,
    backgroundModifier,
    gtmComponentGroup, 
    gtmComponentName,
    gtmLabel,
    showCloseButton,
    showModalTrigger,
    closeModalTrigger,
    centered
  } = props;

  const block = 'c-modal';
  const themeClass = theme === 'light' ? 'light-theme-lighter' : 'dark-theme';

  const showModal = () => {
    publish('trigger-open-overlay', { overlayId: `modal-${id}` }, window);
  };

  const closeModal = () => {
    publish('trigger-close-overlay-externally', {}, window);
  }

  useEffect(() => {
    if(showModalTrigger) {
      showModal();
    }
  }, [showModalTrigger]);

  useEffect(() => {
    if(closeModalTrigger) {
      closeModal();
    }
  }, [closeModalTrigger]);

  return (
    <Overlay
    id={`modal-${id}`}
    brand={brand}
    classes={classNames({
      [`${block}__overlay`]: true,
      [`${block}--${backgroundModifier}`]: backgroundModifier,
      [`c-overlay--centered`]: centered
    })}
    gtmComponentGroup={gtmComponentGroup}
    gtmComponentName={gtmComponentName}
    gtmLabel={gtmLabel}
    showCloseButton={false}
    >
      <CssAnimation 
      enter={{ name: 'slide-up-fade-in', duration: 0.5, easing: 'ease-out', delay: '0, hidden' }} 
      triggerEnter={true} 
      >
        <div
        className={classNames({
          [`${block} ${themeClass}`]: true,
          [classes]: classes
        })}
        >
          {
            showCloseButton &&
              <button 
              className={`${block}__close-btn`} 
              onClick={closeModal}
              aria-label='close modal'
              ></button>
          }
          { children }
        </div>
      </CssAnimation>
    </Overlay>

  );
};

Modal.propTypes = {
  id: propTypes.string.isRequired,
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node
  ]).isRequired,
  brand: propTypes.string,
  theme: propTypes.string,
  backgroundModifier: propTypes.string,
  gtmComponentGroup: propTypes.string,
  gtmComponentName: propTypes.string,
  gtmLabel: propTypes.string,
  showCloseButton: propTypes.bool,
  showModalTrigger: propTypes.bool,
  closeModalTrigger: propTypes.bool
};

Modal.defaultProps = {
  backgroundModifier: 'color-gradient',
  brand: 'lexus',
  theme: 'light',
  showCloseButton: true
};